import {Component, ViewChild, OnInit, HostListener, ElementRef} from '@angular/core';
import {IgxCalendarComponent} from 'igniteui-angular';
import {RightNavComponent} from './right-nav/right-nav.component';
import {Config} from './config/param';
import {MatDialog} from '@angular/material';
import {DatabaseComponent} from './database/database.component';
import {DataService} from './service/data.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'MEDD';
  now : Date = new Date();
  @ViewChild(RightNavComponent, {static: false}) childReference;
  @ViewChild('calendar', {read: IgxCalendarComponent, static: true})

  message = '';

  public calendar: IgxCalendarComponent;

  public databaseUrl = `${Config.API_URL}/download/fileData?filename=database_latest.zip`;

  constructor(
    private dialogue: MatDialog,
    private dataService: DataService,
  ) {
  }


  update() {
    this.dialogue.open(DatabaseComponent, {
      width: '450px',
      disableClose: true
    });
  }

  ngOnInit() {
    this.dataService.getMessage().subscribe((mes) => {
      this.message = mes;
    });

    /* Preloader */
    $(window).on('load', () => {
      const preloaderFadeOutTime = 500;

      function hidePreloader() {
        const preloader = $('.spinner-wrapper');
        setTimeout(() => {
          preloader.fadeOut(preloaderFadeOutTime);
        }, 500);
      }

      hidePreloader();
    });

    // jQuery for page scrolling feature - requires jQuery Easing plugin
    $(() => {
      $(document).on('click', 'a.page-scroll', function (event) {
        const $anchor = $(this);
        $('html, body').stop().animate({
          scrollTop: $($anchor.attr('href')).offset().top
        }, 600, 'easeInOutExpo');
        event.preventDefault();
      });
    });

    // change is-checked class on buttons
    $('.button-group').each(function (i, buttonGroup) {
      const $buttonGroup = $(buttonGroup);
      $buttonGroup.on('click', 'a', () => {
        $buttonGroup.find('.is-checked').removeClass('is-checked');
        $(this).addClass('is-checked');
      });
    });

    // $('#partenaires').hover( () => {
    //   $('#partenaires-list').slideToggle();
    // })
    //
    // $('#partenaires-list').hover( () => {
    //   $('#partenaires-list').slideToggle();
    // })

    /* Removes Long Focus On Buttons */
    $('.button, a, button').mouseup(() => {
      $(this).trigger('blur');
    });
  }


  clickPartnerBurger() {
    $('#partenaires-list-burger').slideToggle();

  }

  closeToogle() {
    $('#partenaires-list-burger').slideUp();
  }

  @HostListener('document:click', ['$event'])
  onClick(event: MouseEvent) {
    const targetElement = event.target as HTMLElement;
    const isClickOnBurger = targetElement.id === 'a-partenaires';
    if (!isClickOnBurger) {
      this.closeToogle();
    }
  }
}
